import React, { Component } from 'react';
import { Common } from '../../core/common';
import { LoginService } from '../../api/login-service';
import Auth from '../_shared/Auth';
import MainManu from '../main-navigation/main-menu';
import { DatetimeInput } from '../../components/input/date-time/main';
import { Input } from '../../components/input/text/main';
import { withRouter } from 'react-router-dom';

let _common: Common;
let _loginService: LoginService;


class Home extends React.Component<any, any> {
  public inputum: HTMLInputElement | null = null;
  public state = { isAuth: 1 };
  constructor(props: any) {
    super(props);
    _loginService = new LoginService();
    _common = new Common();
  }

  public refInput = (event: any) => {
    if (event) {
      this.inputum = event;
    }
  }
  public componentDidMount() {
    if (_common.GetAuthLocalStorage().access_token === '') {
      this.setState({ isAuth: 0 });
    }
  }
  public LogOff = () => {
    _common.ClearAuthLocalStorage();
    this.setState({ isAuth: 0 });
  }
  public toAlms = () => {
    const token: any = localStorage.getItem('access_token');
    const url: string = window.appSettings.ALMS_URL + '/Account/SSO_Alms?token=' + token;
    window.open(url, '_blank');
  };

  public render() {
    return (
      <div>

        <div style={{ padding: '50px' }}>
          <DatetimeInput
            datePickerId={(Math.random() * 10).toString()}
            required={true}
            value={'01-01-1999'}
            mode={'single'}
            enableTime={true}
          />
        </div>
        <img src={_common.GetDefaultImages('_course')} />
        <br />
        <div style={{ padding: '50px' }}>
          <Input type={'text'} refInput={this.refInput} required={true}
            placeHolder={'Kullanıcı Adı Giriniz..'}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Home);
